import React, { useEffect } from 'react';
import {
  FaTimes,
  FaExclamationCircle,
  FaCheckCircle,
  FaExclamationTriangle,
} from 'react-icons/fa';
import styled from 'styled-components';
interface ToastProps {
  type: 'success' | 'error' | 'warning'; // Tipos possíveis para o toast
  message: string; // Texto que será exibido no Toast
  onClose: () => void; // Função chamada quando o Toast for fechado
}
const Toast = ({ type, message, onClose }: ToastProps) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000); // Fecha automaticamente após 3 segundos
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <ToastContainer>
      <ToastContent>
        <Icon>{getIcon(type)}</Icon>
        <Message>{message}</Message>
      </ToastContent>
      <CloseButton onClick={onClose}>
        <FaTimes />
      </CloseButton>
    </ToastContainer>
  );
};

const getIcon = (type: any) => {
  switch (type) {
    case 'success':
      return <FaCheckCircle color="#A7D6C2" />;
    case 'error':
      return <FaExclamationCircle color="#F1B4AB" />;
    case 'warning':
      return <FaExclamationTriangle />;
    default:
      return <FaExclamationCircle />;
  }
};

const ToastContainer = styled.div`
  position: fixed;
  left: 20px;
  bottom: 20px;
  width: 320px;
  background-color: #404040;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  font-size: 14px;
  z-index: 9999999999999999999999;
  @media (max-width: 768px) {
    left: 0;
    right: 0;
    bottom: 20px;
    width: 90%;
    margin: 0 auto;
    justify-content: center;
  }
`;

const ToastContent = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  flex-wrap: wrap; // Permite que o conteúdo quebre para a linha seguinte
`;

const Icon = styled.div`
  margin-right: 10px;
  font-size: 20px;
`;

const Message = styled.span`
  flex: 1;
  white-space: normal; // Permite a quebra de linha no texto
  word-wrap: break-word; // Quebra as palavras longas que ultrapassam o limite do contêiner
  overflow-wrap: break-word; // Garantir que a palavra longa não saia do limite
`;

const CloseButton = styled.div`
  cursor: pointer;
  font-size: 18px;
`;

export default Toast;
